import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import anaConsts from 'analytics/constants';
import subscriptionsSelector from 'selectors/page/autoReplenishment/subscriptions/subscriptionsSelector';
import ShippingAndPaymentInfoSelector from 'selectors/page/autoReplenishment/shippingAndPaymentInfo/shippingAndPaymentInfoSelector';
import { arProfileSubCountsSelector } from 'selectors/user/arProfileSubCountsSelector';

const { shippingAndPaymentInfoSelector } = ShippingAndPaymentInfoSelector;

/**
 * Provides subscription state and current payment data for the AutoReplenishment hub.
 */
export function useSubscriptions() {
    const allSubscriptions = useSelector(subscriptionsSelector);
    const currentSubscriptionPaymentData = useSelector(state => shippingAndPaymentInfoSelector(state)?.payment);
    const profileSubCounts = useSelector(arProfileSubCountsSelector);

    const [currentSubscription, setCurrentSubscriptionState] = useState({});

    const setCurrentSubscription = useCallback(subscription => {
        setCurrentSubscriptionState({
            ...subscription,
            currentSku: {
                // Required for modals and analytics. Do not delete
                ...subscription.items?.[0],
                frequency: subscription.frequency,
                frequencyType: subscription.frequencyType
            }
        });
    }, []);

    const updateCurrentSubscription = useCallback(patch => {
        setCurrentSubscriptionState(prev => ({ ...prev, ...patch }));
    }, []);

    // Track subscription count changes in analytics
    useEffect(() => {
        if (!allSubscriptions.responseStatus) {
            return;
        }

        digitalData.page.attributes.eventStrings = [
            `${anaConsts.Event.AUTO_REPLENISH_ACTIVE_PRODUCTS}=${allSubscriptions.active}`,
            `${anaConsts.Event.AUTO_REPLENISH_PAUSED_PRODUCTS}=${allSubscriptions.paused}`,
            `${anaConsts.Event.PRODUCT_COUNT}=${allSubscriptions.active + allSubscriptions.paused}`
        ];
    }, [allSubscriptions.active, allSubscriptions.paused, allSubscriptions.responseStatus]);

    return {
        allSubscriptions,
        currentSubscription,
        currentSubscriptionPaymentData,
        isSubscriptionsLoaded: Boolean(allSubscriptions.responseStatus),
        profileSubCounts,
        setCurrentSubscription,
        updateCurrentSubscription
    };
}
